import './App.css';
import { BrowserRouter} from "react-router-dom";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { grey } from '@mui/material/colors';
import Routes from "./Routes";
import { AuthContextProvider } from "./providers/AuthContextProvider";
import ConsentBanner from 'components/ConsentBanner';

const defaultTheme = createTheme({
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#fff",       // White background
          color: "#000",                 // Dark text/icons
          boxShadow: "0px 2px 4px rgba(0,0,0,0.1)", // optional subtle shadow
        },
      },
    },
    MuiGrid:{
      styleOverrides: {
        root: {
          padding: 0,
          paddingLeft:0
        },
      },
      variants: [
        {
          props: { variant: 'normal' },
          style: {
            padding:0,
            paddingLeft:0
          },
        },
      ]
    },
    MuiContainer:{
      variants: [
        {
          props: { variant: 'no-color' },
          style: {
            maxWidth:false,
            backgroundColor: grey[200],
            padding:56
          },
        },
      ]
    },
    MuiButton: {
      variants: [ 
        {
          props: { variant: 'google' },
          style: {
            textTransform: 'none',
            //border: `1px solid ${grey[800]}`,
            fontStyle:"normal",
            borderRadius: 4,
            height:38,
            fontWeight:"bold"
          },
        },
        
      ],
    },
  },
  palette: {
      primary: {
        light: "#F4136B",
        main: "#F4136B",
        dark:  "#F4136B",
        contrastText: '#fff',
      },
      secondary: {
        light: "#13007C",
        main: "#13007C",
        dark:  "#13007C",
        contrastText: '#fff',
      },
      background: {
        default: "#f5f5f5!important",   
        paper: "white",
        appbar: "#000"
      }
  },
  typography: {
    h1: {
      fontSize: 72,
      fontWeight: 900, // max bold
      lineHeight: 78 / 70,
      letterSpacing: 1,
    },
    h2: {
      fontSize: 64,
      fontWeight: 900, // max bold
      lineHeight: 1,
      letterSpacing: 2,
    },
    h3: {
      fontSize: 42,
      fontWeight: 'bolder',
      lineHeight: 1,
      letterSpacing: 1,
    },
    h4: {
      fontSize: 36,
      fontWeight: 'bolder',
      fontWeight: 800,
      lineHeight: 1,
      letterSpacing: 1,
    },
    h5: {
      fontSize: 20,
      fontWeight: 600,
      letterSpacing: 1,
    },
    h6: {
      fontSize: 18,
      letterSpacing: 1,
    },
    subtitle1: {
      fontSize: 18,
      letterSpacing: 1,
    },
    subtitle2: {
      fontSize: 16,
      letterSpacing: 1,
    },
    body1: {
      fontWeight: 400,
      fontSize: 15,
      letterSpacing: 1.5,
    },
    body2: {
      fontWeight: 400,
      fontSize: 14,
      letterSpacing: 1.5,
    },
    caption: {
      fontWeight: 400,
      fontSize: 12,
      letterSpacing: 1.5,
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={defaultTheme}>
      <AuthContextProvider>
        {/* Consent Banner must be global */}
        <ConsentBanner />
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
      </AuthContextProvider>
    </ThemeProvider>
  );
}

export default App;
